import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IELearningCommonProps } from '../containers/ELearning';
import TestResult from '../containers/TestResult';
import { IRootState } from '../reducers';

/**
 * テスト結果表示
 * @param props
 */
const ELearningTestResult: React.FC<IProps> = props => {
	if (!props.currentTreeItem) {
		return null;
	}

	return (
		<TestResult
			careerID={props.careerID}
			classID={props.classID}
			testID={props.currentTreeItem.testID as string}
			thistoryID={props.currentTreeItem.id.substr(2)}
			displayStyle={props.currentTreeItem.displayStyle}
			questionGroupDisplay={props.questionGroupDisplay}
		/>
	);
};

const mapStateToProps = (state: IRootState) => ({
	currentTreeItem: state.eLearning.currentTreeItem,
	questionGroupDisplay: state.testResult.questionGroupDisplay,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({});

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

// tslint:disable-next-line: no-empty-interface
export interface IELearningTestResultProps extends IELearningCommonProps {}

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = IELearningTestResultProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(ELearningTestResult);

export default Connected;



// WEBPACK FOOTER //
// ./src/containers/ELearningTestResult.tsx